export default "__VITE_ASSET__f6nUJDD0__"